import Image from "react-bootstrap/Image";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import mcgill from "../assets/images/mcgill.png";

function Education(props) {
  return (
    <Container>
      <Row className="m-2 ">
        <Col className="d-none d-md-block">
          <Image src={mcgill} fluid rounded />
        </Col>
        <Col>
          <h3>Education</h3>
          <h4>Institution: McGill University - Sept. 2015 - April 2019</h4>
          <h5>Major: Information Systems management</h5>
          <h5>Concentration: Business Analytics</h5>
        </Col>
      </Row>
      <hr />
    </Container>
  );
}

export default Education;
